import _ from 'lodash';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RouteReuseStrategyService {

  private navigation = null;
  private shouldReuseRouteCounter = 0;

  public status: boolean = false;
  public routeReuseStrategySubject: Subject<any> = new Subject();

  public get isNavigationStart(): boolean {
    return this.navigation instanceof NavigationStart ? true: false;
  }

  public get isNotNavigationStart(): boolean {
    return this.isNavigationStart ? false: true;
  }

  constructor(
    private router: Router
  ) {
    this.router.events.subscribe(event => {
      if(event instanceof NavigationStart) {
        this.shouldReuseRouteCounter = 0;
        this.navigation = event;
      } else if(event instanceof NavigationEnd) {
        this.shouldReuseRouteCounter = 0;
        this.navigation = event;
      } else if(event instanceof NavigationCancel) {
        this.shouldReuseRouteCounter = 0;
        this.navigation = event;
      } else if(event instanceof NavigationError) {
        this.shouldReuseRouteCounter = 0;
        this.navigation = event;
      }
    });

    this.router.routeReuseStrategy.shouldReuseRoute = (future, current) => {
      if(this.status === false) {
        return false;
      }
      
      if(this.isNotNavigationStart) {
        return false;
      }

      if(this.shouldReuseRouteCounter > 0) {
        return true;
      }

      const [currentRouterStateUrl, currentRouterStateFragment] = current.children[0]['_routerState'].url.split("#");
      const [futureRouterStateUrl, futureRouterStateFragment] = future.children[0]['_routerState'].url.split("#");
      if(currentRouterStateUrl === futureRouterStateUrl) {
        this.shouldReuseRouteCounter++;
        this.routeReuseStrategySubject.next({
          current: {
            url: currentRouterStateUrl,
            fragment: currentRouterStateFragment || ""
          },
          future: {
            url: futureRouterStateUrl,
            fragment: futureRouterStateFragment || ""
          }
        });
        return true;
      }
      return false;
    };
  }

  navigateByUrl(url: string) {
    return this.router.navigateByUrl(url);
  }
}
